<template>
    <div class="footer">
        <div class="footer-content" style="position: relative">
            <div>
                数据统计时长：{{ days }}天
            </div>
            <div class="timer">
                实时数据
                <span style="display: block;width: 0.25rem"></span>
                <div class="year">
                    {{ year }}
                </div>
                <span>/</span>
                <div class="time">
                    {{ month }}
                </div>
                <span>/</span>
                <div class="time">
                    {{ day }}
                </div>

                <span style="display: block;width: 0.25rem"></span>
                <div class="time">
                    {{ hour }}
                </div>
                <span>:</span>
                <div class="time">
                    {{ minute }}
                </div>
                <span>:</span>
                <div class="time">
                    {{ second }}
                </div>

            </div>
            <div style="position: absolute;right: -100%" v-if="false">
                分辨率:{{width}} *{{height}}
            </div>
        </div>
    </div>
</template>

<script>
export default {
	name: "data-view-footer",
	data() {
		return {
			days: 123,
			year: '2025',
			month: '2',
			day: '5',
			hour: '15',
			minute: '30',
			second: '00',
			width: window.screen.width,
			height: window.screen.height
		}

	},
	methods: {
		setDays(days) {
			this.days = days
		},
		getTimes() {
			let date = new Date();
			this.year = date.getFullYear();
			this.month = date.getMonth() + 1;
			this.month = this.month < 10 ? '0' + this.month : this.month;
			this.day = date.getDate();
			this.day = this.day < 10 ? '0' + this.day : this.day;
			this.hour = date.getHours();
			this.hour = this.hour < 10 ? '0' + this.hour : this.hour;
			this.minute = date.getMinutes();
			this.minute = this.minute < 10 ? '0' + this.minute : this.minute;
			this.second = date.getSeconds();
			this.second = this.second < 10 ? '0' + this.second : this.second;
		}
	},
	mounted() {
		this.getTimes();
		setInterval(() => {
			this.getTimes();
		}, 1000)

	}
}
</script>

<style scoped lang="less">
.timer {
  display: flex;
  align-items: center;
  padding-right: 0.5rem;

  span {
    display: block;
    padding-top: 0.1rem;
  }

  .year {
    width: 0.82rem;
    font-size: 0.37rem;
    display: flex;
    align-items: center;
    padding-top: 0.1rem;
  }

  .time {
    width: 0.41rem;
    font-size: 0.37rem;
    align-items: center;
    padding-top: 0.1rem;
  }

}
</style>
